module.exports = "/images/vendor/flag-icon-css/flags/4x3/by.svg?f4cbd761094b27fc253729dfbacfceeb";